import Counter from "./components/Counter";
import String from "./components/String";
import "./App.css"
import Checkbox from "./components/Checkbox";
import Form from "./components/Form";

function App() {
  return (
    <div className="App">
      <Counter/>
      <String/>
      <Checkbox/>
      <Form/>
    </div>
  );
}

export default App;
